/**
 * A global counter that bumps BEFORE every Vite HMR update.
 * Survives module replacement; resets only on a full page reload.
 */

const HMR_STATS = {
  generation: 0
}

/** Read the current HMR generation number. */
export function getHmrGeneration(): number {
  return HMR_STATS.generation
}

/* Increment the counter before Vite applies a hot update. */
if (import.meta.hot) {
  import.meta.hot.on('vite:beforeUpdate', () => {
    HMR_STATS.generation++
  })
}
